/**
 * ================================================================
 * STORIS SKU MANAGER
 * ================================================================
 * Handles dynamic updates of STORIS Product ID when variants change
 * 
 * Dependencies: None (vanilla JavaScript)
 * Initialization: Automatic on DOMContentLoaded
 * 
 * How it works:
 * 1. Reads variant SKU data from DOM (preloaded by Liquid)
 * 2. Listens for variant change events
 * 3. Updates displayed SKU without page reload
 * 4. Shows/hides block based on SKU availability
 * ================================================================
 */

(function() {
  'use strict';
  
  /**
   * Main manager object using module pattern
   * Encapsulates all functionality to avoid global scope pollution
   */
  const StorisSKUManager = {
    
    /**
     * Initialize the manager
     * - Caches DOM elements
     * - Parses variant SKU data
     * - Sets up event listeners
     */
    init: function() {
      // Cache DOM elements for performance
      this.block = document.querySelector('[data-storis-sku-block]');
      this.valueElement = document.querySelector('[data-storis-sku-value]');
      this.dataScript = document.querySelector('[data-storis-sku-data]');
      
      // Exit if block doesn't exist (not added to product page)
      if (!this.block || !this.valueElement || !this.dataScript) {
        return;
      }
      
      // Parse preloaded JSON data
      try {
        this.storisData = JSON.parse(this.dataScript.textContent);
      } catch (error) {
        console.error('[STORIS SKU] Failed to parse variant data:', error);
        return;
      }
      
      // Set up event listeners
      this.bindEvents();
      
      // Optional: Log successful initialization (remove in production)
      if (window.Shopify && window.Shopify.designMode) {
        console.log('[STORIS SKU] Manager initialized successfully');
      }
    },
    
    /**
     * Bind event listeners for variant changes
     * Uses multiple strategies to ensure compatibility
     */
    bindEvents: function() {
      const self = this;
      
      // PRIMARY: Custom variant:change event (Impulse theme standard)
      document.addEventListener('variant:change', function(event) {
        if (event.detail && event.detail.variant) {
          self.updateDisplay(event.detail.variant.id);
        }
      });
      
      // BACKUP: Dropdown variant picker
      const variantSelect = document.querySelector('select[name="id"]');
      if (variantSelect) {
        variantSelect.addEventListener('change', function() {
          self.updateDisplay(this.value);
        });
      }
      
      // BACKUP: Button/radio variant picker
      const variantInputs = document.querySelectorAll('input[name="id"]');
      variantInputs.forEach(function(input) {
        input.addEventListener('change', function() {
          if (this.checked) {
            self.updateDisplay(this.value);
          }
        });
      });
    },
    
    /**
     * Update the displayed STORIS SKU
     * @param {string|number} variantId - ID of selected variant
     */
    updateDisplay: function(variantId) {
      const variantIdStr = String(variantId);
      const storisSku = this.storisData[variantIdStr];
      
      // Update text content
      this.valueElement.textContent = storisSku || '';
      
      // Show/hide block based on SKU availability
      if (storisSku) {
        this.block.style.display = '';
        this.block.setAttribute('aria-hidden', 'false');
      } else {
        this.block.style.display = 'none';
        this.block.setAttribute('aria-hidden', 'true');
      }
    }
  };
  
  /**
   * Initialize when DOM is ready
   * Handles both early and late script loading
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      StorisSKUManager.init();
    });
  } else {
    StorisSKUManager.init();
  }
  
})();